/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：680__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widget: "控件",
    widgetName: "图片框",
    fileId: "图片",
    onImagePress: "被点击",
    width: "宽度",
    height: "高度",
    backgroundColor: "背景颜色"
  }
}
export { r }
